import React, { useEffect, useRef, useState } from 'react';
import ReactECharts from 'echarts-for-react';

const customers = [
    'Alice', 'Bob', 'Charlie', 'Diana', 'Ethan',
    'Fiona', 'George', 'Hannah', 'Ian', 'Julia'
];

const generateData = () => {
    const data = [];
    for (let year = 2000; year <= 2025; year++) {
        customers.forEach(customer => {
            data.push([
                Math.round(1000 + Math.random() * 9000), // CLV
                year,
                customer
            ]);
        });
    }
    return data;
};

const allData = generateData();
const updateFrequency = 5000; // Slower

const getOption = (year, theme) => {
    const yearData = allData.filter(d => d[1] === year);
    const colors = [
        '#5470c6', '#91cc75', '#fac858', '#ee6666',
        '#73c0de', '#3ba272', '#fc8452', '#9a60b4',
        '#ea7ccc', '#2a9d8f'
    ];

    return {
        grid: { top: 10, bottom: 40, left: 70, right: 50 },
        tooltip: {
            trigger: 'item',
            formatter: (params) => `${params.name}: $${params.value}`
        },
        xAxis: {
            max: 'dataMax',
            axisLabel: {
                formatter: val => `$${val}`,
                color: theme === 'dark' ? '#ccc' : '#333',
                rotate: window.innerWidth < 768 ? 45 : 0,
            },
            splitLine: { show: false },
            axisLine: { lineStyle: { color: theme === 'dark' ? '#999' : '#666' } }
        },
        yAxis: {
            type: 'category',
            inverse: true,
            data: yearData.map(d => d[2]),
            axisLabel: {
                color: theme === 'dark' ? '#ccc' : '#333',
                fontSize: 14
            },
            animationDuration: 300,
            animationDurationUpdate: 300
        },
        series: [{
            realtimeSort: true,
            type: 'bar',
            data: yearData.map(d => d[0]),
            itemStyle: {
                color: (params) => colors[params.dataIndex % colors.length]
            },
            label: {
                show: true,
                position: 'right',
                formatter: val => `$${val.value}`,
                color: theme === 'dark' ? '#eee' : '#222'
            }
        }],
        animationDuration: 0,
        animationDurationUpdate: 4000,
        animationEasing: 'linear',
        animationEasingUpdate: 'linear',//linear cubicInOut
        graphic: {
            elements: [{
                type: 'text',
                right: window.innerWidth < 768 ? 0 : 80,
                bottom: 60,
                style: {
                    text: year.toString(),
                    font: 'bolder 60px monospace',
                    fill: theme === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'
                },
                z: 100
            }]
        }
    };
};

const CustomerBarRaceChart = () => {
    const [year, setYear] = useState(2000);
    const [theme, setTheme] = useState('light');
    const [playing, setPlaying] = useState(true);
    const timerRef = useRef(null);

    // Theme detection
    useEffect(() => {
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        const handleChange = () => setTheme(media.matches ? 'dark' : 'light');
        handleChange();
        media.addEventListener('change', handleChange);
        return () => media.removeEventListener('change', handleChange);
    }, []);

    // Animation loop
    useEffect(() => {
        if (playing) {
            timerRef.current = setInterval(() => {
                setYear(prev => (prev < 2025 ? prev + 1 : 2000));
            }, updateFrequency);
        } else {
            clearInterval(timerRef.current);
        }
        return () => clearInterval(timerRef.current);
    }, [playing]);

    const togglePlay = () => setPlaying(!playing);

    return (
        <div className="relative w-full">
            <ReactECharts
                option={getOption(year, theme)}
                style={{ height: '400px', width: '100%' }}
                notMerge={true}
                lazyUpdate={true}
                theme={theme}
            />
            {/* <div className="absolute bottom-4 right-4">
                <button
                    onClick={togglePlay}
                    className="px-4 py-2 rounded bg-indigo-600 text-white shadow hover:bg-indigo-700"
                >
                    {playing ? 'Pause' : 'Play'}
                </button>
            </div> */}
        </div>
    );
};

export default CustomerBarRaceChart;
